import type { FC } from 'react';


import { Text } from '@eneco/custom-components/Graph';
import { useFormatter } from '@eneco/i18n';
import { theme } from '@eneco/sparky/theme';
import type { ScaleLinear } from 'd3-scale';

import { graphColors } from '../../../../utils/constants';



type PeakPriceLimitRightAxisLabelProps = {
  yScale: ScaleLinear<number, number, never>;
  threshold: number;
};

export const PeakPriceLimitRightAxisLabel: FC<PeakPriceLimitRightAxisLabelProps> = ({ yScale, threshold }) => {
  const { currency } = useFormatter();
  return (
    <g>
      <line
        x1={0}
        x2={5}
        y1={yScale(threshold)}
        y2={yScale(threshold)}
        stroke={theme.colors.brandOrange}
        strokeWidth="1"
      />
      <rect
        fill={theme.colors.brandOrange}
        x={5}
        y={yScale(threshold) - 11}
        width="55"
        height="20"
        rx="8"
      />
      <Text x={6.5} y={yScale(threshold)} dx="0.25em" dy="0.25em" fill={graphColors['textInverted']}>
        {currency.euro(threshold)}
      </Text>
    </g>
  );
};
